import React from 'react';

export const InvalidTokenPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col" dir="ltr">
      {/* Header */}
      <header className="bg-blue-700 shadow-md">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <h1 className="text-xl md:text-2xl font-bold text-white">Grade Submission</h1>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow flex items-center justify-center py-12 px-4">
        <div className="max-w-md w-full space-y-6">
          <div className="text-center">
            <svg
              className="mx-auto h-12 w-12 text-red-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <h2 className="mt-4 text-2xl font-bold text-gray-900">Invalid Link</h2>
            <p className="mt-2 text-gray-600">
              This grade submission link is invalid or has expired.
            </p>
          </div>

          <div className="bg-white shadow-lg rounded-lg overflow-hidden">
            <div className="px-6 py-6 sm:px-10 sm:py-8">
              <div className="text-center space-y-4">
                <p className="text-gray-700">
                  We couldn't find a valid task associated with this link.
                </p>
                <div className="pt-4">
                  <p className="text-gray-500 text-sm">
                    Please contact us on WhatsApp for a new grade submission link.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-6">
        <div className="max-w-4xl mx-auto px-4">
          <p className="text-center text-sm text-gray-500">&copy; {new Date().getFullYear()} YMY. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};
